export default __webpack_public_path__ + "static/media/outstanding-invoices.18e0ba02.svg";